<template>
    <!-- this is the Vue component for the posts feed -->
    <div ref="feed">
        <template v-if="settings !== false">
            <modal-delete-feed-item v-if="popup_open && popup_name === 'delete_feed_item'"></modal-delete-feed-item>
            <modal-edit-topic v-if="popup_open && popup_name === 'edit_topic'"></modal-edit-topic>
            <modal-edit-poll v-if="popup_open && popup_name === 'edit_poll'"></modal-edit-poll>

            <transition-group name="topic-fade-grow"
                :class="{ 'compact-posts-wrapper': displayMode === 'small' && !isHelpdesk && !is_helpdesk_prop }">
                <div v-for="(topic, index) in orderedTopics" v-if="!loading" :key="topic.id">
                    <!-- Event slider -->
                    <events-slider v-if="showEventSlider && index === 4"></events-slider>

                    <!-- Groups slider -->
                    <groups-slider v-if="showGroupsSlider && index === 8"></groups-slider>

                    <!-- Poll-->
                    <template v-if="topic.post_type == 'poll' && topic.status != 'non_active'">
                        <poll :focusCommentByHashId="focusCommentByHashId" :viewType="viewType"
                            :singleTopic="singleTopicId" :topic="topic"
                            v-if="!loading && topic.ticket_status === helpdeskFilter || helpdeskFilter === 'all' || !topic.ticket_status">
                        </poll>
                    </template>

                    <template v-else-if="topic.group.id && !groupRoute">
                        <group-topic :focusCommentByHashId="focusCommentByHashId" :viewType="viewType"
                            :singleTopic="singleTopicId" :topic="topic"
                            v-if="!loading && topic.ticket_status === helpdeskFilter || helpdeskFilter === 'all' || !topic.ticket_status">
                        </group-topic>
                    </template>

                    <!-- Normal topic/Event topic -->
                    <template v-else>
                        <topic :focusCommentByHashId="focusCommentByHashId" :viewType="viewType"
                            :singleTopic="singleTopicId" :topic="topic"
                            v-if="!loading && topic.ticket_status === helpdeskFilter || helpdeskFilter === 'all' || !topic.ticket_status">
                        </topic>
                    </template>
                </div>
            </transition-group>
            <div class="tw-flex tw-justify-center" v-if="!loading && topics.length === 0">
                <topics-empty-state-svg></topics-empty-state-svg>
            </div>
            <template v-if="loading || currently_paginating">
                <div class="topic-skeleton-wrapper card card-shadow overflow-hidden"
                    v-for="n in skeletonCount.topicCount">
                    <div class="skeleton-animation"></div>
                    <div class="card-inner flex">
                        <div class="topic-user-icon"></div>
                        <div class="flex-1">
                            <div class="topic-title"></div>
                            <div class="topic-author-info"></div>
                            <div class="topic-content-1"></div>
                            <div class="topic-content-2"></div>
                        </div>
                    </div>
                    <div class="card-inner background-lightblue flex center-vertical">
                        <div class="topic-stats-item"></div>
                        <div class="topic-stats-item"></div>
                        <div class="topic-stats-item"></div>
                    </div>
                    <div class="card-inner background-lightblue topic-comments">
                        <div class="flex" v-for="x in skeletonCount.commentCount">
                            <div class="topic-user-icon"></div>
                            <div class="flex-1">
                                <div class="topic-new-comment"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <ajaxspinner></ajaxspinner>
            <topicerror></topicerror>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios'
import orderBy from 'lodash.orderby';
import reject from 'lodash.reject';

import Global from '../../mixins/Global.js'
import Modal from '../../mixins/v2/Modal';

import DeleteFeedItem from '../modals/DeleteFeedItem.vue';
import EditTopic from '../modals/EditTopic.vue';
import EditPoll from '../modals/EditPoll.vue';
import TopicsEmpty from '@/resources/assets/js/vue/components/community/TopicsEmpty';

let pluralize = require('pluralize');
const debounce = require('lodash.debounce');

export default {
    name: 'Feed',

    mixins: [Global, Modal],

    components: {
        'modal-delete-feed-item': DeleteFeedItem,
        'modal-edit-topic': EditTopic,
        'modal-edit-poll': EditPoll,
        'topics-empty-state-svg': TopicsEmpty,
    },

    data() {
        return {
            loading: true,
            failed: false,
            pagination: false,
            currently_paginating: false,
            focusCommentByHashId: false,
            visibleTopics: false,
            isHelpdesk: isHelpdesk, // whether the current board is a helpdesk board
            component_is_destroyed: false,
        }
    },

    props: {
        singleTopicId: {
            default: false
        },
        singleTopicType: {
            default: false
        },
        singleTopicBoardSlug: {
            default: false
        },
        customSource: {
            default: false
        },
        boardType: {
            default: false
        },
        userId: {
            default: false
        },
        viewType: {
            default: 'default'
        },
        topicData: {
            default: false
        },
        isDynamic: {
            default: true
        },
        board_id_prop: {
            default: false,
        },
        is_helpdesk_prop: { // whether this topic is a helpdesk topic
            default: false,
        },
        feed_type: {
            default: false,
        },
        query_params: {
            default: false,
        },
    },

    computed: {
        ...mapState([
            'topics',
            'helpdeskFilter',
            'displayMode',
            'activeBoard'
        ]),

        orderedTopics() {
            if (this.isDynamic === true) {
                //if feed switch is set on newest, filter by date
                //if(this.feedSwitch === true ) {
                let topics = this.topics;

                //if there is a stickied topic that has not yet been read on first page load, put it at the top
                /* if(this.pagination.current_page === 1 || topics.length === 0) {
                    topics = orderBy(topics, filter(topics, { 'sticky': true, 'unread': true}), 'desc');
                } */

                // topics = orderBy(topics, 'updated_at', 'desc');

                topics = orderBy(topics, 'sticky', 'desc');

                //order by newly created so that a newly created topic always appears on top of the page
                topics = orderBy(topics, 'newly_created', 'desc');

                //remove moodboard topics
                topics = reject(topics, ['board_type', 'moodboard']);

                //remove topics that is no read permission for and when the topic_preview settings is turned off
                //this should be caught in the backend, but the trending topics are cached and therefore we can't right now
                //this is only the case for the 'trending' topics
                topics = reject(topics, ((topic) => {
                    return !topic.permissions.includes('READ') && this.settings.show_topic_preview !== '1';
                }));

                //remove helpdesk topics when not in helpdesk
                if (!isHelpdesk && !this.is_helpdesk_prop) {
                    topics = reject(topics, ['board_type', 'helpdesk']);
                }

                //remove topics with an empty board type (which are topics in groups) if the feed isnt a group or singular feed
                if (boardId === -1 && !this.board_id_prop && !this.singleTopicId) {
                    topics = reject(topics, ['board_type', false]);
                }

                return topics;
                //} else {
                //    return orderBy(this.topics, 'newly_created', 'desc');
                //}
                //return orderBy(this.topics, 'sticky', 'desc');
            } else {
                let topics = [];
                topics.push(this.topicData);

                return topics;
            }
        },

        feedSwitch: {
            get() {
                return this.$store.state.feedSwitch;
            }
        },

        skeletonCount() {
            if (!this.singleTopicId) {
                return {
                    topicCount: 3,
                    commentCount: 1,
                }
            }

            return {
                topicCount: 1,
                commentCount: 3,
            }
        },

        showGroupsSlider() {
            return !this.board_id_prop && boardId === -1 && this.plugins.groups && this.plugins.groups === 'installed';
        },

        showEventSlider() {
            return !this.board_id_prop && boardId === -1;
        },

        groupRoute() {
            if (typeof this.$route.matched[0] !== 'undefined' && this.$route.matched[0].path === '/groups') {
                return true;
            }

            return false;
        },
    },

    created() {
        //listen to scroll
        if (!this.singleTopicId) {
            window.addEventListener('scroll', this.handleScroll);
        }

        let hash = window.location.hash;

        if (hash !== '' && this.singleTopicId) {
            hash = hash.substr(1);
            hash = decodeURI(hash);
            hash = hash.substr(5);

            this.focusCommentByHashId = hash;
        }
    },

    mounted() {
        //only load feed if the feed switch is off, else the topics are already being loaded through an watcher
        if (!this.feedSwitch) {
            this.getFeedTopics();
        }

        //if the topic is a moodpost and the view is single-topic, redirect to the associated moodboard
        if (this.singleTopicId && this.singleTopicType === 'moodboard') {
            window.location = '/boards/' + this.singleTopicBoardSlug + '#topicid-' + this.singleTopicId;
        }
    },

    destroyed() {
        this.component_is_destroyed = true;

        //remove scroll listener
        if (!this.singleTopicId) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    },

    methods: {
        handleScroll: debounce(function scroll() {
            // see if scrolled near bottom of feed
            // window.innerHeight + window.pageYOffset + 1500 = screen height + amount scrolled + the offset we want to start fetching topics from
            // $feed.offsetHeight + $feed.offsetTop = the height of the feed and the spacing from the top of the page
            if ((window.innerHeight + window.pageYOffset + 1500) >= (this.$refs.feed.offsetHeight + this.$refs.feed.offsetTop) && this.topics.length > 0 && !this.failed) {
                setTimeout(async () => {
                    await this.paginate();

                    if(this.orderedTopics.length === 0) {
                      this.paginate();
                    }
                }, 100);
            }
        }, 100),

        getFeedTopics(paginate) {
            //if feed is based on axios results
            if (this.isDynamic === true) {
                //if full load and not pagination
                if (!paginate) {
                    //start the loading spinner
                    this.loading = true;

                    //reset the feed
                    this.$store.commit('resetFeed');
                }

                let url = '/api/v3/topics';

                if (this.singleTopicId) {
                    url += '/' + this.singleTopicId;
                }

                let params = new URLSearchParams();

                if ((boardId !== -1 || this.board_id_prop) && !this.customSource) {
                    if (boardId !== -1) {
                        params.append('board_id', boardId);
                    } else {
                        params.append('board_id', this.board_id_prop);
                    }
                }

                if (this.isHelpdesk) {
                    params.append('type', 'helpdesk');
                }
                if ((this.feedSwitch === true && boardId === -1 && !this.board_id_prop && !this.singleTopicId && !this.userId) || this.feed_type === 'popular') {
                    params.append('type', 'popular');
                }

                if (this.customSource && this.boardType) {
                    params.append('type', this.boardType);
                }

                if (this.customSource && this.userId) {
                    params.append('type', 'user');
                    params.append('user_id', this.userId);
                }

                //if paginating, get the next page of topics
                if (paginate) {
                    params.append('page', this.pagination.current_page + 1);
                }

                // if this is a infinite scroll like homepage or board, limit the result
                if (!this.singleTopicId) {
                    params.append('limit', 20);
                }

                if (this.query_params !== false) {
                    const query_params = this.query_params.split(/\s*,\s*/);

                    for (let i = 0; i < query_params.length; i += 1) {
                        const query = query_params[i].split(/\s*=\s*/);

                        params.append(query[0], query[1]);
                    }
                }

                let request = {
                    params: params
                };

                //request feed data
                axios.get(url, request)
                    .then((response) => {
                        if (!this.component_is_destroyed) {
                            //feed data
                            var topics = response.data;

                            if (this.singleTopicId) {
                                var data_models = [
                                    {
                                        model: 'Topic',
                                        source: 'data',
                                        nested_models: [
                                            {
                                                model: 'User',
                                                source: 'user',
                                                storage: 'users',
                                                child_key: 'user_id'
                                            },
                                            {
                                                model: 'Comment',
                                                source: 'posts',
                                                storage: 'comments',
                                                parent_key: 'conversation_id',
                                                nested_models: [
                                                    {
                                                        model: 'Reply',
                                                        source: 'replies',
                                                        storage: 'replies',
                                                        parent_key: 'comment_id',
                                                        nested_models: [
                                                            {
                                                                model: 'Like',
                                                                source: 'liked_by',
                                                                storage: 'likes',
                                                                parent_key: 'reply_id',
                                                            },
                                                            {
                                                                model: 'User',
                                                                source: 'user',
                                                                storage: 'users',
                                                                child_key: 'user_id'
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        model: 'Like',
                                                        source: 'liked_by',
                                                        storage: 'likes',
                                                        parent_key: 'comment_id',
                                                    },
                                                    {
                                                        model: 'User',
                                                        source: 'user',
                                                        storage: 'users',
                                                        child_key: 'user_id'
                                                    },
                                                ]
                                            },
                                            //replies are for top-level comments
                                            {
                                                model: 'Comment',
                                                source: 'replies',
                                                storage: 'comments',
                                                parent_key: 'conversation_id',
                                                nested_models: [
                                                    {
                                                        model: 'Reply',
                                                        source: 'replies',
                                                        storage: 'replies',
                                                        parent_key: 'comment_id',
                                                        nested_models: [
                                                            {
                                                                model: 'Like',
                                                                source: 'liked_by',
                                                                storage: 'likes',
                                                                parent_key: 'reply_id',
                                                            },
                                                            {
                                                                model: 'User',
                                                                source: 'user',
                                                                storage: 'users',
                                                                child_key: 'user_id'
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        model: 'Like',
                                                        source: 'liked_by',
                                                        storage: 'likes',
                                                        parent_key: 'comment_id',
                                                    },
                                                    {
                                                        model: 'User',
                                                        source: 'user',
                                                        storage: 'users',
                                                        child_key: 'user_id'
                                                    },
                                                ]
                                            },
                                            {
                                                model: 'Like',
                                                source: 'liked_by',
                                                storage: 'likes',
                                                parent_key: 'conversation_id',
                                            }
                                        ]
                                    },
                                ];
                            } else {
                                var data_models = [
                                    {
                                        model: 'Topic',
                                        source: 'data',
                                        nested_models: [
                                            {
                                                model: 'User',
                                                source: 'user',
                                                storage: 'users',
                                                child_key: 'user_id'
                                            },
                                            {
                                                model: 'Like',
                                                source: 'liked_by',
                                                storage: 'likes',
                                                parent_key: 'conversation_id',
                                            }
                                        ]
                                    }
                                ]
                            }

                            ActiveDataStore.activeDataSetup(data_models, topics);

                            //pagination data
                            if (response.data.meta) {
                                this.pagination = response.data.meta.pagination;
                            }

                            this.loading = false;

                            this.currently_paginating = false;

                            this.$nextTick(() => {
                                //find mentions
                                //previous page fix, in case vue is loaded before the plugins are
                                if (typeof ($('.post-wrapper').mentionify()) !== "undefined") {
                                    $('.post-wrapper').mentionify();
                                }

                                this.refreshStickySidebar();
                            });

                            if (this.pagination.count === 0 && this.pagination.current_page < this.pagination.last_page) {
                                this.paginate();
                            }
                        }
                    }, error => {
                        this.failed = true;
                        this.loading = false;
                        this.currently_paginating = false;
                    });
            } else {
                if (this.topicData) {
                    this.failed = true;
                    this.loading = false;
                    this.currently_paginating = false;
                }

                //find mentions
                this.$nextTick(() => {
                    //previous page fix, in case vue is loaded before the plugins are
                    if (typeof ($('.post-wrapper').mentionify()) !== "undefined") {
                        $('.post-wrapper').mentionify();
                    }
                });
            }
        },

        paginate() {
            let pagination = this.pagination;

            //if there are more topics that can be loaded
            if (pagination.current_page < pagination.total_pages && !this.currently_paginating) {
                this.currently_paginating = true;
                this.getFeedTopics(true);
            }
        },
    },

    watch: {
        feedSwitch() {
            this.getFeedTopics();
        },

        orderedTopics() {
            //if the feed is dynamic
            if (this.isDynamic) {
                //if there arent any topics that can be shown, the page is not paginating but the page has paginated before
                if (this.orderedTopics.length < 6 && !this.currently_paginating && this.pagination) {
                    //paginate again
                    this.paginate();
                }
            }

        },
    },
}
</script>

<style lang="scss">
.compact-posts-wrapper {
    background: #fff;
    display: block;
    box-shadow: 0 3px 6px #c3c3c3, 0 3px 6px rgba(195, 195, 195, 0.23);
    border-radius: 3px;
}

.post-wrapper {
    .post-comments {
        .card-comments {
            .comment-wrapper {
                .comment-reply-to-vue-inline {
                    i {
                        padding-right: 4px;
                    }
                }

                .comment-replies {
                    .comment-reply-to-vue {
                        margin-top: 10px;
                        padding-bottom: 10px;

                        // comment reply without background and animate padding on activate
                        .froala-wrapper {
                            .fr-box {
                                transition: background .15s;
                                background: none;

                                &.fr-basic {
                                    .fr-element {
                                        padding: 0;
                                        min-height: 0;
                                    }

                                    .fr-wrapper {
                                        &.show-placeholder {
                                            .fr-placeholder {
                                                padding: 0 !important;
                                            }
                                        }
                                    }
                                }

                                &.active,
                                &.idle {
                                    cursor: text;

                                    &.fr-basic {
                                        .fr-element {
                                            transition: padding .15s, min-height .15s;
                                            padding: 14px;
                                            min-height: 48px;

                                            @media(max-width: 550px) {
                                                min-height: 40px !important;
                                                padding: 9px !important;
                                            }
                                        }

                                        .fr-wrapper {
                                            &.show-placeholder {
                                                .fr-placeholder {
                                                    transition: padding .15s;
                                                    padding: 14px !important;

                                                    @media(max-width: 550px) {
                                                        padding: 9px !important;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }

                                &.idle {
                                    background: #f0f0f1;
                                }

                                &.active {
                                    background: #eaecef;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .post-media-mobile-toggle {
        position: relative;
        margin-top: 8px;
        width: 15px;
        text-align: center;
        margin-right: -60px;

        &.animate-toggle {
            &:after {
                content: "";
                position: absolute;
                background: whitesmoke;
                opacity: 0;
                padding: 1px;
                border-radius: 100%;
                top: 5px;
                z-index: 0;
                transform: scale(12);
                right: 7px;
                animation-name: media-toggle-animation;
                animation-duration: 0.35s;

                &:hover {
                    cursor: default;
                }
            }

            &.blue-bg {
                &:after {
                    background: #e7e7f1;
                }
            }
        }

        @keyframes media-toggle-animation {
            0% {
                opacity: 0;
                transform: scale(1);
            }

            50% {
                opacity: 0.3;
                transform: scale(12);
            }

            80% {
                opacity: 0.3;
                transform: scale(12);
            }

            100% {
                opacity: 0;
                transform: scale(1);
            }
        }

        &.reply-media-toggle {
            @media(min-width: 1100px) {
                display: none !important;
            }
        }
    }

    &.compact {
        background: none;
        box-shadow: none !important;
        margin-bottom: 0;
        border-radius: 0;

        .post-top {
            .birthday-topic-balloon {
                max-width: 60px;
                right: auto;
                left: 80px;
                top: 15px;
            }

            .card-inner {
                padding-bottom: 0;

                @media(max-width: 576px) {
                    padding-top: 15px;
                    padding-left: 15px;
                    padding-right: 15px;
                }
            }
        }

        .post-top-content {
            .post-timestamp {
                margin-bottom: 2px;
                margin-top: 7px;
                margin-left: 0;

                &:before {
                    display: none;
                }
            }

            .post-top-content-name {
                margin-bottom: 0;
            }

            .post-top-content-title {
                margin-bottom: 0;

                .post-title {
                    font-size: 15px;
                    max-width: 100%;

                    .post-related-board-wrapper {
                        .post-related-board-name {
                            line-height: 19px;
                        }
                    }
                }
            }

            .post-top-content-name {
                display: inline-block;
                font-size: 12px;
            }

            .post-timestamp {
                display: inline-block;
                font-size: 12px;

                &.latest-comment {
                    padding-left: 0;

                    i {
                        padding-right: 3px;
                    }
                }
            }

            .post-content {
                display: none !important;
            }

            .responsive-video {
                display: none;
            }

            .post-attachments {
                display: none;
            }
        }

        .post-stats {
            background: none;
            display: flex;
            margin-left: 97px;
            padding-bottom: 25px;
            border-bottom: 1px solid whitesmoke;
            margin-right: 22px;
            margin-top: 5px;

            .post-statistics {
                padding: 0;
            }

            .post-likes-count,
            .post-comments-count,
            .post-views-count {
                font-size: 12px;

                i,
                p {
                    font-size: 12px;
                }

                p {
                    padding-left: 5px;
                }
            }

            .post-comments-count,
            .post-views-count {
                margin-left: 10px;
            }

            @media(max-width: 576px) {
                margin-left: 77px;
                padding-bottom: 15px;
            }
        }

        .post-comments {
            display: none;
        }

        &:last-of-type {
            .post-stats {
                border-bottom: 0;
                padding-bottom: 12px;
            }
        }
    }

    &.single-topic {
        .post-comments {
            .card-comments {
                .comment-wrapper {
                    .comment-text {
                        .message-content {
                            br {
                                display: initial;
                            }
                        }
                    }
                }
            }
        }
    }

    &.quiz-loading {
        opacity: 0.5;
    }
}

//reply add/delete animation
.simple-conversation-fade-enter-active,
.simple-conversation-fade-leave-active {
    transition: opacity 0.2s ease-in-out;
}

.simple-conversation-fade-enter,
.simple-conversation-fade-leave-to {
    opacity: 0;
}

//topic fade + grow/shrink
.topic-fade-grow-enter-active {
    transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.topic-fade-grow-leave-active {
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.topic-fade-grow-enter {
    @media(min-width: 767px) {
        opacity: 0;
        transform: translateY(-10px);
    }
}

.topic-fade-grow-leave-to {
    @media(min-width: 767px) {
        opacity: 0;
        transform: translateY(-50px);
    }
}
</style>
